import type {RepositoryPickerRepository$data as Repository} from '@github-ui/item-picker/repository'
import {PencilIcon, RepoIcon} from '@primer/octicons-react'
import {Box, Button, Text} from '@primer/react'
import type {IssueCreatePayload} from '.'
import {useEffect, useRef} from 'react'
import {LABELS} from './constants'

export type TemplatePickerButtonProps = {
  repository: Repository | undefined
  template: IssueCreatePayload | undefined
  onClick: () => void
}

export function TemplatePickerButton({repository, template, onClick}: TemplatePickerButtonProps) {
  const templateText = template ? template.name : LABELS.blankIssueName
  const templatePickerButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    templatePickerButtonRef.current?.focus()
  }, [])

  return (
    <Box>
      <Button onClick={onClick} leadingVisual={RepoIcon} trailingVisual={PencilIcon} ref={templatePickerButtonRef}>
        {repository && (
          <span>
            {templateText} <Text sx={{fontWeight: 'light'}}>in</Text> {repository.owner.login}/{repository.name}
          </span>
        )}
        {!repository && <>Select a repository</>}
      </Button>
    </Box>
  )
}

try{ TemplatePickerButton.displayName ||= 'TemplatePickerButton' } catch {}